<template>
  <div style="height: 100%">
    <div class="mb-3">
      <v-autocomplete
        class="fix-google-chrome"
        v-model="selectedEmployeeGroup"
        :items="employeesGroup"
        item-text="title_th"
        item-value="employee_group_uuid"
        outlined
        dense
        hide-details
        label="กลุ่มพนักงาน"
        @change="handleSelectedEmployeeGroup"
        :loading="loadingSelectedEmployeeGroup"
      >
      </v-autocomplete>
    </div>
    <div class="px-4 pb-2 d-flex justify-space-between align-center">
      <v-checkbox
        v-model="checkedAll"
        hide-details
        dense
        @change="handleCheckAll($event)"
        :disabled="!selectedEmployeeGroup"
      >
        <template v-slot:label>
          <span class="body-2">เลือกทั้งหมด</span>
        </template>
      </v-checkbox>
      <div>
        <span class="caption grey--text text--darken-2"
          >{{
            checkedAll ? totalEmployeesGroupMember : selectedEmployees.length
          }}
          รายการ</span
        >
      </div>
    </div>
    <div
      :style="`height: calc(100% - 195px); border: 1px solid #bdbdbd; ${
        checkedAll ? 'overflow-y: hidden' : 'overflow-y: auto'
      }`"
    >
      <DynamicScroller
        :items="employeesGroupMember"
        :min-item-size="pagination.limit"
        key-field="employee_uuid"
        class="px-2 py-2"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :data-index="index"
          >
            <div>
              <div
                class="px-2 py-2 d-flex justify-space-between"
                v-observe-visibility="
                  item.employee_uuid ===
                    lastEmployeesGroupMember.employee_uuid &&
                  !isEmployeesGroupMemberLastPage
                    ? infiniteScrollHandlerEmployeesGroupMember
                    : false
                "
              >
                <div class="d-flex">
                  <v-checkbox
                    v-model="checkedEmployee[item.employee_uuid]"
                    @change="handleCheckEmployee($event, item)"
                    class="pt-0 mt-0"
                    hide-details
                    dense
                    :id="item.employee_uuid"
                    :value="checkedAll"
                    :disabled="checkedAll"
                  >
                  </v-checkbox>
                  <label :for="item.employee_uuid" style="margin-top: 1px">
                    <div class="body-2">
                      {{ item.firstname_th }}
                      {{ item.lastname_th }} ({{ item.employee_code }})
                    </div>
                    <div class="body-2 grey--text">
                      {{ item.organization ? item.organization.title_th : '' }}
                    </div>
                  </label>
                </div>
              </div>
              <v-divider></v-divider>
            </div>
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>
      <div v-if="pagination.isLoading">
        <div class="px-2">
          <v-card
            color="#f5f5f5"
            v-for="num in 10"
            :key="num"
            outlined
            class="px-4 py-2 mb-2"
          >
            <Skeleton width="200px" />
            <Skeleton :count="1" />
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from 'vue-loading-skeleton'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import { mapActions } from 'vuex'

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default {
  components: {
    DynamicScroller,
    DynamicScrollerItem,
    Skeleton,
  },
  props: {
    selectedEmployees: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      checkedAll: false,
      loadingSelectedEmployeeGroup: false,
      selectedEmployeeGroup: null,
      checkedEmployee: {},
      pagination: {
        currentPage: 1,
        limit: 10,
        isLoading: false,
      },
      employeesGroupMember: [],
      totalEmployeesGroupMember: 0,
    }
  },
  computed: {
    lastEmployeesGroupMember() {
      const [lastItem] = this.employeesGroupMember.slice(-1)
      return lastItem || {}
    },
    isEmployeesGroupMemberLastPage() {
      return (
        this.pagination.currentPage ===
        Math.ceil(this.totalEmployeesGroupMember / this.pagination.limit)
      )
    },
    employeesGroup() {
      return this.$store.state.employeesGroup.employeesGroup
    },
  },
  async created() {
    await this.getEmployeesGroup()
  },
  methods: {
    ...mapActions({
      fetchEmployeesGroup: 'employeesGroup/fetchEmployeesGroup',
      fetchEmployeesGroupMember: 'employeesGroup/fetchEmployeesGroupMember',
    }),
    async handleSelectedEmployeeGroup() {
      this.$emit('onClearEmployees')
      this.$emit('onClearEmployeeGroup')
      this.checkedAll = false
      this.checkedEmployee = {}

      this.employeesGroupMember = []
      this.totalEmployeesGroupMember = 0
      this.pagination.currentPage = 1
      await this.getEmployeesGroupMember()
    },
    handleCheckAll(value) {
      this.$emit('onCheckAllEmployeeGroup', value, this.selectedEmployeeGroup)
      // this.checkedEmployee = {}
    },
    handleCheckEmployee(value, employee) {
      this.$emit('onCheckEmployee', value, employee)
    },
    async getEmployeesGroup() {
      try {
        this.loadingSelectedEmployeeGroup = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'access-authority-employee-to-list-access-employee-group',
          },
        }

        await this.fetchEmployeesGroup(payload)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingSelectedEmployeeGroup = false
      }
    },
    async getEmployeesGroupMember() {
      try {
        this.pagination.isLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          employee_group_uuid: this.selectedEmployeeGroup,
          params: {
            dpc: 'access-authority-employee-to-list-access-employee-group-member',
            is_active: true,
            limit: `${this.pagination.limit},${
              (this.pagination.currentPage - 1) * this.pagination.limit
            }`,
            is_policy_tag: true,
          },
        }
        const { total: totalEmployeesGroupMember, data: employeesGroupMember } =
          await this.fetchEmployeesGroupMember(payload)
        this.totalEmployeesGroupMember = totalEmployeesGroupMember
        this.setEmployeesGroupMember(employeesGroupMember)
        this.pagination.isLoading = false
      } catch (error) {
        this.pagination.isLoading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async getNextEmployeesGroupMember() {
      try {
        this.pagination.currentPage += 1

        await this.getEmployeesGroupMember()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    setEmployeesGroupMember(employeesGroupMember) {
      this.employeesGroupMember = [
        ...this.employeesGroupMember,
        ...employeesGroupMember,
      ]
    },
    infiniteScrollHandlerEmployeesGroupMember(isVisible, entry) {
      if (isVisible && entry.isIntersecting) {
        this.getNextEmployeesGroupMember()
      }
    },
  },
}
</script>
